module.exports = __webpack_public_path__ + "img/calendar-wait.9b5331e9.svg";